import { UiDetailsCard } from '@ui/molecules-details-card';

import type { WrapperProps } from './Wrapper.types';

export function Wrapper({
  children,
  onChangeBankClick,
  additionalInfo,
  changeBankButtonTestId,
  changeBankButtonAriaLabel,
  changeBankButtonLabel,
  ...rest
}: WrapperProps) {
  return (
    <UiDetailsCard.Wrapper
      onChangeClick={onChangeBankClick}
      changeButtonTestId={changeBankButtonTestId}
      changeButtonAriaLabel={changeBankButtonAriaLabel}
      changeLabel={changeBankButtonLabel}
      additionalInfoProps={{
        children: additionalInfo,
        variant: 'info',
      }}
      {...rest}
    >
      {children}
    </UiDetailsCard.Wrapper>
  );
}
